// extracted by mini-css-extract-plugin
export default {"loginInput":"edituser_loginInput__CuMN1","lableText":"edituser_lableText__tSQJa","buttoncls":"edituser_buttoncls__eukOn","normalBtncls":"edituser_normalBtncls__jybo8"};